import React from 'react';
import { Row, Col, Typography, theme, Grid } from 'antd';
import { PaperClipOutlined, LoadingOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import _ from 'lodash';
import GeneralHelper from '../../../../helpers/general';
import AssetHelper from '../../../../helpers/asset';

const { Text } = Typography;
const { useToken } = theme;
const { useBreakpoint } = Grid;

const CustomItemRender = ({ file, assets, onDelete }) => {
	const screens = useBreakpoint();
	const { token } = useToken();
	const { colorNeutral, colorLink } = token;
	const fileNameLimit = screens.xs ? 10 : 30;

	const fileExtension = file && file.type ? file.type.split('/') : '';

	const getFileIconColor = (status) => {
		const statusColor = status === 'error' ? '#ff4d4f' : ( status === 'done' ? '#8c8c8c' : colorNeutral);
		return statusColor;
	};

	const getFileNameColor = (status) => {
		const statusColor = status === 'error' ? '#ff4d4f' : ( status === 'done' ? colorLink : colorNeutral);
		return statusColor;
	};

	return (
		<Row justify="space-between">
			<Col align="start">
				{ file.status === 'done' || file.status === 'error' ?
					<PaperClipOutlined style={{ color: getFileIconColor(file.status), marginRight: 6 }} />
					:
					<LoadingOutlined
						style={{ marginRight: 6, color: '#8c8c8c', fontSize: 16 }}
						spin
					/>
				}
				{file.status !== 'done' ?
					<Text style={{ color: getFileNameColor(file.status) }}>
						{GeneralHelper.truncateFileName(file.name, fileNameLimit, fileExtension[1])}
					</Text> :
					(
						!_.isEmpty(assets) ?
							<Text>{GeneralHelper.truncateFileName(file.name, fileNameLimit, fileExtension[1])}</Text>
							:
							<a
								href={AssetHelper.getDownloadUrl(file.asset_id)}
								target="_blank"
								style={{ color: getFileNameColor(file.status) }}
								rel="noreferrer"
							>{GeneralHelper.truncateFileName(file.name, fileNameLimit, fileExtension[1])}
							</a>
					)
				}
			</Col>
			<Col align="end">
				{!_.isEmpty(assets) && file.status === 'done' ?
					<Text style={{ fontSize: 12 }}>{file.created_at ? dayjs(file.created_at).format('MM-DD-YYYY HH:mm') : ''}</Text> :
					<DeleteOutlined
						onClick={() => {
							onDelete();
						}}
						style={{ cursor: 'pointer', color: getFileIconColor(file.status)  }}
					/>
				}
			</Col>
		</Row>
	);
};

export default CustomItemRender;